import React from "react";
import createReactClass from "create-react-class";
import Immutable from "immutable";
import ReactPropTypes from "prop-types";
import ImmutablePropTypes from "react-immutable-proptypes";
import {faBuilding} from "@fortawesome/pro-regular-svg-icons";

import InfiniteListSelect from "js/common/views/infinite-loading/infinite-list-select";
import * as ajax from "js/common/ajax";

export default createReactClass({

  propTypes: {
    onChange: ReactPropTypes.func.isRequired,
    clientIds: ImmutablePropTypes.list,
    isDisabled: ReactPropTypes.bool
  },

  getInitialState() {
    return {selectedItems: Immutable.Set()};
  },

  getDefaultProps() {
    return {clientIds: Immutable.List()};
  },

  componentDidMount() {
    if (!this.props.clientIds.isEmpty()) {
      fetchInitialClients(this.props.clientIds)
          .then(items => this.setState({selectedItems: items}));
    }
  },

  componentDidUpdate(prevProps) {
    if (!Immutable.is(prevProps.clientIds, this.props.clientIds)) {
      if (this.props.clientIds.isEmpty()) {
        this.setState({selectedItems: Immutable.Set()});
      } else {
        fetchInitialClients(this.props.clientIds)
            .then(items => this.setState({selectedItems: items}));
      }
    }
  },

  handleChange(items) {
    this.setState({selectedItems: items});
    this.props.onChange(items.map(item => item.get("id")).toList());
  },

  render() {
    return <InfiniteListSelect
        searchUrl="entity-finder/search"
        searchParams={{entity: "CLIENT"}}
        searchResultToItem={searchResultToItem}
        placeholder=" Search for Clients"
        selectedItems={this.state.selectedItems}
        itemIcon={faBuilding}
        onChange={this.handleChange}
        disabled={this.props.isDisabled}
    />;
  }

});

const searchResultToItem = result => Immutable.Map({
  id: result.get("id"),
  name: result.get("originalCrmId") + " - " + result.get("name")
});

const fetchInitialClients = clientIds =>
    ajax.post({
      url: "entity-finder",
      json: {
        ids: clientIds.toJS(),
        entityType: "CLIENT"
      }
    }).then(items => Immutable.fromJS(items).map(searchResultToItem).toSet());
